import { USER_PROFILE } from '@/config/userProfile'

function firstNameFromEmail(email) {
  if (typeof email !== 'string' || !email.includes('@')) return null
  const local = email.split('@')[0].trim()
  if (!local) return null
  const firstSegment = local.split(/[._-]+/)[0]
  if (!firstSegment) return null
  return firstSegment.charAt(0).toUpperCase() + firstSegment.slice(1).toLowerCase()
}

function fullNameFromSession(user) {
  const candidates = [
    [user?.first_name ?? user?.firstName, user?.last_name ?? user?.lastName].filter(Boolean).join(' '),
    user?.name,
    user?.full_name,
    user?.fullName,
    user?.display_name,
    user?.displayName,
    user?.user_metadata?.first_name,
    user?.user_metadata?.last_name && user?.user_metadata?.first_name ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}` : null,
    user?.user_metadata?.name,
    user?.user_metadata?.full_name,
    user?.user_metadata?.display_name,
  ]
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c.trim()
  }
  const email = user?.email ?? user?.user_metadata?.email
  const first = firstNameFromEmail(email)
  if (first) return first
  return null
}

export function accountFromSession(session) {
  const user = session?.user ?? session
  const email = user?.email ?? session?.email ?? ''
  const fullName = fullNameFromSession(user) || (email ? firstNameFromEmail(email) : null) || USER_PROFILE.fullName
  return {
    fullName,
    email: email || USER_PROFILE.email,
  }
}
